import register from 'preact-custom-element';
import SocialProof from './SocialProof';
import { useRef } from 'preact/hooks';
import socialProofGenerator from './social-proof-generator';

function Loader() {
  const messages = useRef(socialProofGenerator({ minTimeout: 7500, maxTimeout: 15000, }));
  return <SocialProof messages={messages.current} />
}

register(Loader, 'social-proof',);
